import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const code = searchParams.get('code');

      if (!code) {
        if (!cancelled) setStatus('error');
        setTimeout(() => {
          if (!cancelled) navigate('/auth/login', { replace: true });
        }, 2000);
        return;
      }

      const { error } = await supabase.auth.exchangeCodeForSession(code);

      if (error) {
        if (!cancelled) setStatus('error');
        setTimeout(() => {
          if (!cancelled) navigate('/auth/login', { replace: true });
        }, 2000);
        return;
      }

      if (!cancelled) setStatus('success');

      const isRecovery = searchParams.get('type') === 'recovery';
      const rawNext = searchParams.get('next');

      let dest = '/dashboard';

      if (isRecovery) {
        dest = '/auth/reset-password';
      } else if (rawNext) {
        const isValid =
          rawNext.startsWith('/') &&
          !rawNext.startsWith('//') &&
          rawNext !== '/auth' &&
          !rawNext.startsWith('/auth/');
        if (isValid) {
          dest = rawNext;
        }
      }

      setTimeout(() => {
        if (!cancelled) navigate(dest, { replace: true });
      }, 1200);
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 rounded-full bg-primary-500/10">
          {status === 'loading' && (
            <i className="ri-loader-4-line text-3xl text-primary-400 animate-spin" />
          )}
          {status === 'success' && (
            <i className="ri-check-line text-3xl text-primary-400" />
          )}
          {status === 'error' && (
            <i className="ri-error-warning-line text-3xl text-red-400" />
          )}
        </div>

        <h1 className="font-heading font-bold text-xl text-foreground-50 mb-2">
          {status === 'loading' && 'Authentification en cours...'}
          {status === 'success' && 'Connexion réussie !'}
          {status === 'error' && 'Erreur de connexion'}
        </h1>
        <p className="text-sm text-foreground-400">
          {status === 'loading' && 'Veuillez patienter pendant que nous vérifions votre session.'}
          {status === 'success' && 'Redirection vers votre espace...'}
          {status === 'error' && 'Le code d\'authentification est invalide ou a expiré.'}
        </p>
      </div>
    </div>
  );
}

export default AuthCallback;